export class NoticeEdit
{
    public id = null;
    public text = '';
    public active = true;
    public startOn: Date = null;
    public endOn: Date = null;
    public priority: string;
    public canDismiss = true;
}
